import { render, staticRenderFns } from "./ColumnBulkSelectButton.vue?vue&type=template&id=52f89ea4&scoped=true&"
import script from "./ColumnBulkSelectButton.vue?vue&type=script&lang=js&"
export * from "./ColumnBulkSelectButton.vue?vue&type=script&lang=js&"
import style0 from "./ColumnBulkSelectButton.vue?vue&type=style&index=0&id=52f89ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f89ea4",
  null
  
)

export default component.exports